"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateUserPermission = exports.UserPermissionSchema = exports.ModuleVisibilitySchema = exports.FieldVisibilitySchema = exports.AccessLevelSchema = void 0;
exports.canAccessModule = canAccessModule;
exports.canAccessField = canAccessField;
const zod_1 = require("zod");
exports.AccessLevelSchema = zod_1.z.union([zod_1.z.literal('none'), zod_1.z.literal('read'), zod_1.z.literal('write')]);
exports.FieldVisibilitySchema = zod_1.z.union([zod_1.z.literal('none'), zod_1.z.literal('own'), zod_1.z.literal('all')]);
exports.ModuleVisibilitySchema = zod_1.z.object({
    level: exports.AccessLevelSchema,
    fields: zod_1.z.object({
        details: exports.FieldVisibilitySchema,
        pricing: exports.FieldVisibilitySchema.optional(),
    }),
});
exports.UserPermissionSchema = zod_1.z.object({
    name: zod_1.z.string(),
    schemaVersion: zod_1.z.number(),
    companySettings: exports.ModuleVisibilitySchema,
    quotes: exports.ModuleVisibilitySchema,
    jobs: exports.ModuleVisibilitySchema,
    variations: exports.ModuleVisibilitySchema,
    invoices: exports.ModuleVisibilitySchema,
    customers: exports.ModuleVisibilitySchema,
    calendar: exports.ModuleVisibilitySchema,
    priceBook: exports.ModuleVisibilitySchema,
    todos: exports.ModuleVisibilitySchema,
});
const validateUserPermission = (data) => {
    return exports.UserPermissionSchema.safeParse(data).success;
};
exports.validateUserPermission = validateUserPermission;
// if (validateUserPermission({})) {
//   console.log('Input is valid!');
// } else {
//   console.error('Validation failed:', [...validateUserPermission.Errors({})]);
// }
function canAccessModule(module, action) {
    if (module.level === 'none')
        return false;
    if (module.level === 'read' && action === 'write')
        return false;
    return true;
}
function canAccessField(visibility, ownerId, currentUserId) {
    if (!visibility || visibility === 'none')
        return false;
    if (visibility === 'all')
        return true;
    if (visibility === 'own' && ownerId && currentUserId) {
        return ownerId === currentUserId;
    }
    return false;
}
